import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

export interface SeoConfig {
  title: string;
  description: string;
  keywords?: string;
  url?: string;
  image?: string;
  type?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SeoService {
  private defaultTitle = 'Bayou Lacombe Museum | Historic 1912 Schoolhouse & Choctaw Heritage — Lacombe, Louisiana';
  private defaultDescription = 'Explore 300+ years of Northshore history at Bayou Lacombe Museum. Discover Choctaw heritage, Father Adrien Rouquette (Chahta-Ima), the 1912 historic wooden schoolhouse, events, and native gardens. Open Saturdays Noon–4 PM.';
  private defaultImage = 'https://images.ctfassets.net/f6ou4743hwzs/2xaL3IYyS5iU8bcXoWAOdX/9d1784950839614bbbcaa593c23ee090/whyblm.jpg';
  private baseUrl = 'https://bayoulacombemuseum.com';

  constructor(private titleService: Title, private metaService: Meta) {}

  updateTags(config: Partial<SeoConfig>) {
    const fullTitle = config.title 
      ? `${config.title} | Bayou Lacombe Museum`
      : this.defaultTitle;
    const description = config.description || this.defaultDescription;
    const image = config.image || this.defaultImage;
    const url = config.url ? `${this.baseUrl}${config.url}` : this.baseUrl;
    const type = config.type || 'website';
    const keywords = config.keywords || 'Bayou Lacombe Museum, Lacombe Louisiana, St Tammany Parish history, Choctaw history Louisiana, Father Adrien Rouquette, Chahta-Ima, historic schoolhouse, Northshore Louisiana museums, things to do in Lacombe LA';

    // Set page title
    this.titleService.setTitle(fullTitle);

    // Standard HTML meta
    this.metaService.updateTag({ name: 'description', content: description });
    this.metaService.updateTag({ name: 'keywords', content: keywords });
    this.metaService.updateTag({ name: 'author', content: 'Bayou Lacombe Museum' });

    // Open Graph (Facebook, LinkedIn, iMessage)
    this.metaService.updateTag({ property: 'og:title', content: fullTitle });
    this.metaService.updateTag({ property: 'og:description', content: description });
    this.metaService.updateTag({ property: 'og:image', content: image });
    this.metaService.updateTag({ property: 'og:url', content: url });
    this.metaService.updateTag({ property: 'og:type', content: type });
    this.metaService.updateTag({ property: 'og:site_name', content: 'Bayou Lacombe Museum' });

    // Twitter Card
    this.metaService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.metaService.updateTag({ name: 'twitter:title', content: fullTitle });
    this.metaService.updateTag({ name: 'twitter:description', content: description });
    this.metaService.updateTag({ name: 'twitter:image', content: image });
  }
}
